import { useRef, useEffect, useState } from 'react';

export default function Contact(){
    const h2Ref = useRef(null);
    const [inView, setInView] = useState(false);

    useEffect(() => {
        const observer = new window.IntersectionObserver(
            ([entry]) => {
                setInView(entry.isIntersecting);
            },
            { threshold: 0.3 }
        );
        if (h2Ref.current) observer.observe(h2Ref.current);
        return () => observer.disconnect();
    }, []);

    return (
                <div className="max-w-4xl mx-auto">
          <h2
            ref={h2Ref}
            className={`text-3xl font-bold mb-12 text-center transition-all duration-700 ${inView ? 'animate-fadeInUp' : 'opacity-0'}`}
          >
            Get In Touch
          </h2>
          <div className="bg-black border border-gray-800 p-8 rounded-lg shadow-md">
            <form
            ref={h2Ref}
            className={`text-3xl font-bold mb-12 text-center transition-all duration-700 ${inView ? 'animate-fadeInUp' : 'opacity-0'}`}>
              <div className="grid gap-6 mb-6 md:grid-cols-2">
                <div>
                  <label className="block mb-2 text-sm font-medium">First Name</label>
                  <input 
                    type="text"
                    placeholder="First Name"
                    className="w-full bg-black px-4 py-2 border text-[15px] border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block mb-2 text-sm font-medium">Last Name</label>
                  <input 
                    type="text"
                    placeholder="Last Name"
                    className="w-full bg-black px-4 py-2 border text-[15px] border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>
              <div className="mb-6">
                <label className="block mb-2 text-sm font-medium">Email</label>
                <input 
                  type="email"
                  placeholder="abc@gmail.com"
                  className="w-full bg-black px-4 py-2 border text-[15px] border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div className="mb-6">
                <label className="block mb-2 text-sm font-medium">Message</label>
                <textarea 
                  rows="4"
                  placeholder="Write your message..."
                  className="w-full bg-black px-4 py-2 border text-[15px] border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                ></textarea>
              </div>
              <button 
                type="submit"
                className="w-full bg-[#5e0a57] px-6 py-3 bg-blue-600 text-[20px] text-white rounded-md hover:bg-[#2b0528]"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>
    );
}